// ConfirmPassword
import { ConfirmPassword } from '@bz/account';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    dialog: {
      get title() {
        return t('Password confirmation');
      },

      // title: () => t('login'),
      class: 'w-[500px] h-[700px]',
    },
  },
};

export default ConfirmPassword;
